@if (mode === 'ReadOnly') {
{{control?.value ?? emptyText}}
} @else {
<ng-select [searchFn]="searchFn" [items]="$data()" bindLabel="name" bindValue="_id" [placeholder]="placeholder" [searchable]="true" [formControl]="control" [multiple]="multiple">
</ng-select>
}